/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/prop-types */
import React from 'react';
import { Label, TextInput, SelectDropdown } from '@gsa/afp-component-library';
import { useFormContext, Controller } from 'react-hook-form';
import './upiid-number.scss';

const UpiidNumber = ({
  isAacDisabled,
  isSqDisabled,
  control,
  aacOptions,
  defaultUpiidAAC,
}) => {
  const {
    formState: { errors },
    clearErrors,
    setValue,
  } = useFormContext();

  // Set default value for upiidAAC if provided
  React.useEffect(() => {
    if (defaultUpiidAAC) {
      setValue('upiidAAC', defaultUpiidAAC);
    }
  }, [defaultUpiidAAC, setValue]);

  const resetDuplicateUpiidError = () => {
    clearErrors('upiidAACRenewal');
    clearErrors('upiidSQRenewal');
  };

  return (
    <div className="upiid-container">
      <div tabIndex={0}>
        <Label required>Solicitation uPIID Number</Label>
      </div>

      <div className="grid-row grid-gap-2 flex-align-end">
        <div className="desktop:grid-col-2 display-flex flex-row align-items-end">
          <div
            className={`width-full ${errors.upiidAACRenewal ? 'usa-form-group--error' : ''}`}
          >
            <div className="usa-hint">6 character AAC</div>
            <Controller
              name="upiidAAC"
              control={control}
              render={({ field }) => (
                <SelectDropdown
                  {...field}
                  aria-label="6 character AAC"
                  data-testid="upiid-aac"
                  options={aacOptions}
                  disabled={isAacDisabled}
                  onFocus={resetDuplicateUpiidError}
                  containerClassName="margin-top-0"
                  className="width-full"
                />
              )}
            />
          </div>
        </div>
        <div className="desktop:grid-col-3 display-flex flex-row upiid-box">
          <Controller
            name="upiidSQ"
            control={control}
            render={({ field }) => (
              <TextInput
                {...field}
                aria-label="2 digit fiscal year, 1 character instrument type, 4 position sequence number"
                data-testid="upiid-sq"
                help="2 digit fiscal year, 1 character instrument type, 4 position sequence number"
                maxLength="7"
                style={{ textTransform: 'uppercase' }}
                errorMessage={errors.upiidSQ?.message}
                readOnly={isSqDisabled}
                containerClassName={
                  errors.upiidSQRenewal ? 'usa-form-group--error' : ''
                }
                variant={errors.upiidSQRenewal ? 'error' : ''}
                onFocus={resetDuplicateUpiidError}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default UpiidNumber;
